import React, { useState, useEffect, useCallback } from 'react';
import { Alert, Grid, LinearProgress } from '@mui/material';
import Footer from 'src/components/Footer';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { getDiscountCode, parseToApiErrorMessage } from 'src/services/apiService';
import Results from './Results';
import { Customer, Discount } from 'src/services/apiService/response-models';
// import PageHeader from 'src/components/page-header';
import PageHeader from './PageHeader';
import CreateCustomerDialog from '../create-customer-dialog';
import useRefMounted from 'src/hooks/useRefMounted';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

function ManageDiscount() {
  const [discount, setDiscount] = useState<Discount[]>([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const isMountedRef = useRefMounted();
  const { enqueueSnackbar } = useSnackbar();
  const { t }: { t: any } = useTranslation();
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [hasDataLoadError, setHasDataLoadError] = useState(false);
  const [isCreateCustomerDialogOpen, setIsCreateCustomerDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  const fetchDiscountData = useCallback(async () => {
    try {
      setIsDataLoading(true);
      setHasDataLoadError(false);

      const response = await getDiscountCode();
    console.log(response);

      // if (isMountedRef.current) {
        setDiscount(response.data);
      // }
    } catch (err) {
      setHasDataLoadError(true);
      const msg = parseToApiErrorMessage(err, 'Failed to load customer data');
      enqueueSnackbar(t(msg), { variant: 'error' });
      console.error(err);
    }
    setIsDataLoading(false);
  }, [isMountedRef]);

  useEffect(() => {
    setIsDataLoading(true);
    fetchDiscountData();
    
  }, [!isCreateCustomerDialogOpen,fetchDiscountData]);

  const onDeleteSuccess =async () => {
    await fetchDiscountData();
}
const handleOpenCreateCustomerDialog = () => {
  setIsCreateCustomerDialogOpen(true);
};

const handleCloseCreateCustomerDialog = () => {
  setIsCreateCustomerDialogOpen(false);
};
  return (
    <>
      <PageTitleWrapper>
      {/* <PageHeader type="list" title="Customers Management" 
      subtitle="All aspects related to the app customers can be managed from this page"
       route="add" 
       buttonTitle="Create customer"></PageHeader> */}
       <PageHeader
         isCreateCustomerDialogOpen={isCreateCustomerDialogOpen}
         onOpenCreateCustomerDialog={handleOpenCreateCustomerDialog}
         onCloseCreateCustomerDialog={handleCloseCreateCustomerDialog}
       ></PageHeader>
      </PageTitleWrapper>

      <Grid
        sx={{
          px: 4
        }}
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        spacing={4}
      >
        <Grid item xs={12}>
        {!isDataLoading && hasDataLoadError && <Alert severity="error">Failed to load data</Alert>}
                    {isDataLoading && <LinearProgress />}
          <Results customers={discount} onDeleteSuccess={onDeleteSuccess}/>
        </Grid>
      </Grid>
      <Footer />
    </>
  );
}

export default ManageDiscount;
